import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=f6657e2e&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6657e2e')) {
      api.createRecord('f6657e2e', component.options)
    } else {
      api.reload('f6657e2e', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=f6657e2e&", function () {
      api.rerender('f6657e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nem3AAHsRlXA/JS/comp/FavElement.vue"
export default component.exports